import {
  PageBlueprint,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';
import SecurityIcon from '@material-ui/icons/Security';
import { rootRouteRef } from './routes';

export const ACCESS_PAGE_TABS = [
  { path: 'bindings', title: 'Assignments' },
  { path: 'roles', title: 'Access Roles' },
  { path: 'rbac', title: 'ADP Permissions' },
  { path: 'reconciler', title: 'Access Synchronization' },
  { path: 'audit-log', title: 'Audit Log' },
] as const;

export const accessPage = PageBlueprint.make({
  params: {
    path: '/access',
    title: 'Access',
    icon: <SecurityIcon />,
    routeRef: rootRouteRef,
  },
});

export const accessRolesPage = SubPageBlueprint.make({
  name: 'roles',
  params: {
    path: ACCESS_PAGE_TABS[1].path,
    title: ACCESS_PAGE_TABS[1].title,
    loader: async () =>
      import('../components/AccessRolesPage').then(module => (
        <module.AccessRolesPage />
      )),
  },
});

export const accessBindingsPage = SubPageBlueprint.make({
  name: 'bindings',
  params: {
    path: ACCESS_PAGE_TABS[0].path,
    title: ACCESS_PAGE_TABS[0].title,
    loader: async () =>
      import('../components/AccessBindingsPage').then(module => (
        <module.AccessBindingsPage />
      )),
  },
});

export const accessReconcilerPage = SubPageBlueprint.make({
  name: 'reconciler',
  params: {
    path: ACCESS_PAGE_TABS[3].path,
    title: ACCESS_PAGE_TABS[3].title,
    loader: async () =>
      import('../components/AccessReconcilerPage').then(module => (
        <module.AccessReconcilerPage />
      )),
  },
});

export const accessAuditLogPage = SubPageBlueprint.make({
  name: 'audit-log',
  params: {
    path: ACCESS_PAGE_TABS[4].path,
    title: ACCESS_PAGE_TABS[4].title,
    loader: async () =>
      import('../components/AccessAuditLogPage').then(module => (
        <module.AccessAuditLogPage />
      )),
  },
});
